const shouldShowVenueLink = (gid) => {
  return (gid || '').includes('ontruck:');
};

export default shouldShowVenueLink;
